import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _excluded = ["_styles", "styles"],
  _excluded2 = ["styles"];
import React from 'react';
import { sstyled } from "../styled/index.mjs";
import { STATIC_COMPONENT } from "./staticChildren.mjs";
export var STYLES_CONTEXT = Symbol('STYLES_CONTEXT');
var STYLES_SELF = Symbol('STYLES_SELF');
function Enhancement(childComponents, Context) {
  return {
    condition: function condition(Component) {
      return Boolean(Component.style || Component[STATIC_COMPONENT]);
    },
    init: function init(props, WrapperComponent) {
      if (props.styles) {
        this[STYLES_SELF] = props.styles;
      }
      if (WrapperComponent.style) {
        this[STYLES_SELF] = sstyled.merge(WrapperComponent.style, props._styles);
      }
    },
    context: function context(_context) {
      // Optimization: if has no children there is no need to create new context (by lsroman)
      if (!this[STYLES_SELF] || !Object.keys(childComponents).length) {
        return _context;
      }
      return _objectSpread(_objectSpread({}, _context), {}, _defineProperty({}, STYLES_CONTEXT, this[STYLES_SELF]));
    },
    asProps: function asProps(_ref) {
      var _styles = _ref._styles,
        styles = _ref.styles,
        props = _objectWithoutProperties(_ref, _excluded);
      return _objectSpread(_objectSpread({}, props), {}, {
        styles: this[STYLES_SELF]
      });
    },
    wrapperProps: function wrapperProps(_ref2) {
      var styles = _ref2.styles,
        props = _objectWithoutProperties(_ref2, _excluded2);
      var context = React.useContext(Context);
      return _objectSpread(_objectSpread({}, props), {}, {
        _styles: styles,
        styles: context[STYLES_CONTEXT]
      });
    }
  };
}
export default Enhancement;
//# sourceMappingURL=style.mjs.map